import React from 'react';
import './About.css';

const keyPoints = [
  'Experienced & Dedicated Faculty',
  'Small Batch Sizes (Max 15)',
  'Personalized Attention for Every Student',
  'Regular Tests & Assessments',
  'Comprehensive Study Material Provided',
  'Proven Track Record Since 2009',
];

export default function About() {
  return (
    <div className="about">
      <div className="about__container">
        <div className="about__text">
          <p className="about__label">Our Story</p>
          <h2 className="about__title">About Triumph Classes</h2>
          <div className="section-divider" style={{ margin: '0.75rem 0 1.5rem' }}></div>
          <p className="about__desc">
            Founded in 2009, Triumph Classes was established with a single mission — to make quality education
            accessible and effective for every student. Over 15 years, we have helped thousands of students
            achieve academic excellence and unlock their true potential.
          </p>
          <p className="about__desc">
            We believe every student is unique. Our approach combines structured curriculum, small interactive
            batches, and regular feedback to ensure no one is left behind. Our dedicated teachers go beyond
            textbooks to build concepts that last a lifetime.
          </p>
          <ul className="about__points">
            {keyPoints.map((point) => (
              <li key={point} className="about__point">
                <span className="about__check">✓</span>
                {point}
              </li>
            ))}
          </ul>
        </div>
        <div className="about__visual">
          <div className="about__image-placeholder">
            <div className="about__image-inner">
              <div className="about__icon-grid">
                <div className="about__icon-card">📚<span>Quality Education</span></div>
                <div className="about__icon-card">🎯<span>Focused Learning</span></div>
                <div className="about__icon-card">🏆<span>Proven Results</span></div>
                <div className="about__icon-card">💡<span>Smart Teaching</span></div>
              </div>
              <div className="about__badge-float">
                <strong>15+</strong>
                <span>Years of Excellence</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
